<template>
    <div class="ccpay-security">
        <div class="ccpay-security-header">
                <span @click="back"> 退後</span>
                <span >个人資訊与安全</span>
                <span></span>
         </div>
         <div class="ccpay-security-connect">
             <ul>
                <li style="font-weight: 600;color: black;">
                    基本資訊    
                </li>
                 <li >
                    帳戶：{{userinfo.mobile}}
                </li>
                 <li >
                    名稱：{{userinfo.name}}
                </li>
                <li style="font-weight: 600;color: black;">
                    基本資訊  
                </li>
                 <li v-show="userinfo.mobile">
                     <span class="ccpay-s-c-s--l"> 手机号</span>
                    {{userinfo.mobile.replace(/^(\d{3})\d{4}(\d+)/,"$1****$2")}}
                 <!--   <span class="span">{{userinfo.mobile?'解绑':'绑定'}} </span> -->
                      
                </li>
                 <li v-show="userinfo.email">
                    <span class="ccpay-s-c-s--l"> 邮箱</span> {{
                        replaceAll(userinfo.email)
                    }}
                    <!-- <span class="span"> {{userinfo.email?'解绑':'绑定'}}  </span>-->
                </li>
                <li > <span class="ccpay-s-c-s--l">谷歌验证码</span> {{userinfo.authGoogleCode==1?'已绑定':'未绑定'}}
                    <span class="span" @click="changecode('googole',userinfo.authGoogleCode)"> {{userinfo.authGoogleCode==1?'解绑':'绑定'}}</span>
                </li>
                <li ><span class="ccpay-s-c-s--l">登錄密码</span> ******
                    <span class="span" @click="changecode('password','password')">  更改</span>
                </li>
            </ul>
         </div>
    </div>
</template>

<script>
import {setCookie,setElpCookie,ccpayUser,getCookie,Formatnumbers} from '../../public/index.js'
import { Indicator } from 'mint-ui';
export default {
    data(){
        return {
            userinfo:{}
        }
    },
    mounted(){
        // this.userinfo =   JSON.parse(getCookie('ccpayUser'))
        Indicator.open();
        this.$axios.get('/v1/account/info').then(res=>{
               Indicator.close();
            if(res.code==0){
                ccpayUser(JSON.stringify(res.data),30)
                this.userinfo =   res.data
            }
        })
        // console.log(this.userinfo,'userinfo')
    },
    methods:{
         back(){
            this.$router.go(-1)
        },
        replaceAll(email){
                 var arr = email.split("@");
                var star = "";
                if (arr[0].length <= 3) {
                    star = "*";
                    arr[0] = arr[0].substr(0, arr[0].length - 1) + star;
                } else {
                    star = "***";
                    arr[0] = arr[0].substr(0, arr[0].length - 3) + star;
                }
                return email = arr[0] + "@" + arr[1];
        },
        changecode(type,istype){
            if(istype=="password"){
                 this.$router.push({
                    path:'/changeCode',
                    query:{type:type}
                })
            }else{
                if(istype==0){
                     this.$router.push({
                        path:'/Googlecode',
                    })
                }else{
                    this.$router.push({
                    path:'/changeCode',
                        query:{type:type}
                    })
                }
            }
        }   
    }
}
</script>

<style lang="scss" scoped>
    .ccpay-security{
         height: 100%;;
         background: white;
        .ccpay-security-header{
                background: white;
                display: flex;
                justify-content: space-between;
                padding: 1rem;
        }
        .ccpay-security-connect{
            padding: 1rem;
            padding-right: 2rem;
            background: white;
            ul li{
                position: relative;
                padding: 1.125rem 0rem;
                color: #666;
                font-size: 0.93rem;
                border-bottom: 1px solid;
                border-color: #eee;
                .span{
                    float: right;
                    color:#26a2ff;
                }
                a{
                    color: #666;
                }
            }
        }
        .ccpay-s-c-s--l{
            float: none;
            width: 6rem;
            display: inline-block;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/my/security.vue